export default {
  dbh_home: 'Home',
  dbh_dashboard: 'Dashboard',
  dbh_datalab: 'Datalab',
  dbh_ai: 'AI',
  dbh_intelligence: 'Intelligence',
  dbh_opinion: 'Opinions',
  dbh_marketing: 'Marketing Hub',
  dbh_databrain: 'Databrain',
  dbh_gpop: 'G-POP',
  dbh_mgmt: 'Mgmt',
  dbh_studio_hub: 'Studio Hub',
  dbh_benchmark: 'Benchmark',
  dbh_user_center: 'User Center',
  dbh_explore: 'Explore',
  dbh_following: 'Following',
  dbh_iegglobal: 'IEG Global Games',
  dbh_getgameaccess: 'Request Data Access',
  dbh_bigriser: 'Big Riser',
  dbh_mentions: 'Mentions',
  dbh_sentiment: 'Sentiment',
  dbh_score: 'Score',
  dbh_top_free: 'Top Free',
  dbh_top_paid: 'Top Paid',
  dbh_store_topSeller: 'Store TopSeller',
  dbh_keywords: 'Keywords',
  dbh_news: 'News',
  dbh_more: 'More',
  dbh_learnmore: 'Learn More',
  dbh_competitor: 'Competitor',
  dbh_publisher: 'Publisher',
  dbh_downloads: 'Downloads',
  dbh_upcoming: 'Upcoming',

  dbh_all: 'All Games',
  dbh_mobile: 'Mobile',
  dbh_pc: 'PC',
  dbh_console: 'Console',
  dbh_pcconsole: 'PC & Console',
  dbh_company: 'Company',
  dbh_table_disablegame_tip: `The chart shows a max of 10 games, please deselect existing games before adding new one.`,

  dbh_bigriser_games: 'Big Riser',
  dbh_noteworthy_games: 'Noteworthy Games',
  dbh_newrelease_mobile_games: 'New Release Mobile Games',
  dbh_newrelease_pc_games: 'New Release PC Games',
  dbh_newrelease_console_games: 'New Release Console Games',
  dbh_upcoming_mobile_games: 'Upcoming Mobile Games',
  dbh_upcoming_pc_games: 'Upcoming PC Games',
  dbh_upcoming_console_games: 'Upcoming Console Games',
  dbh_game_firstly_breaking: 'Game: Firstly breaking into the TOP',

  dbh_spotlight_noteworthy_games: 'Noteworthy Games',
  dbh_spotlight_newrelease_mobile_games: '30-Day New Release Mobile Games',
  dbh_spotlight_newrelease_pc_games: '30-Day New Release PC Games',
  dbh_spotlight_newrelease_console_games: '30-Day New Release Console Games',
  dbh_spotlight_upcoming_mobile_games: '180-Day Upcoming Mobile Games',
  dbh_spotlight_upcoming_pc_games: '180-Day Upcoming PC Games',
  dbh_spotlight_upcoming_console_games: '180-Day Upcoming Console Games',
  dbh_spotlight_big_risers: '7-Day Active Big Risers',

  dbh_spotlight_no_data: 'No Data',
  dbh_spotlight_newrelease_mobile_nodata: 'No New Release Mobile Games entered the App Store Free Top 10.',
  dbh_spotlight_trailer_views: 'Trailer Views',
  dbh_spotlight_pre_registration_top5: 'Pre-Registration #1-5',
  dbh_spotlight_upcoming_mobile_nodata: 'No IGN Trailer Data for Upcoming Mobile Games.',
  dbh_spotlight_tip_pre_registration_ranking_data_of:
    'Ranking Data of {chartSource} comes from {googlePlaySource}. ',
  dbh_spotlight_tip_pre_registration_count_countries:
    'Count the number of countries that entered the Top 5 of the Pre-Registration Chart on that day.',
  dbh_spotlight_bigriser_mobile_nodata: 'No games show significant active user growth (>18%).',
  dbh_spotlight_units: 'Units',
  dbh_spotlight_wishlist: 'Wishlist',
  dbh_spotlight_newrelease_top10: 'New Release #1-10',
  dbh_spotlight_comingsoon_top10: 'Coming Soon #1-10',
  dbh_spotlight_newrelease_console_nodata: 'No New Release Console Games entered the Playstation New Release Top 10.',
  dbh_spotlight_upcoming_console_nodata: 'No Upcoming Console Games entered the Playstation Coming Soon Top 10.',
  dbh_spotlight_bigriser_nodata: 'No games show significant active user growth (>18%).',

  dbh_announcements: 'Announcements',
  dbh_global_holidays: 'Global Holidays',
  dbh_recentlyviewed: 'Recently Viewed',
  dbh_recently_dashboard: 'Dashboard',
  dbh_recently_intelligence: 'Intelligence',
  dbh_recently_opinions: 'Opinions',
  // dbh_recentlyviewed_tip: 'Data is yet to be ready',
  dbh_datasources: 'Data Sources',
  dbh_datasmap: 'Data Map',
  dbh_datasmap_games: 'Games',
  dbh_datasmap_companies: 'Companies',
  dbh_mobiledataBrain_title: 'Mobile DataBrain',
  dbh_mobiledataBrain_desc: 'WeChat Mini Program',

  dbh_storerank_topnewfree: 'Top New Free',
  dbh_storerank_topfree: 'Top Free',
  dbh_storerank_topgrossing: 'Top Grossing',
  dbh_storerank_topnewpaid: 'Top New Paid',
  dbh_storerank_toppaid: 'Top Paid',
  dbh_storerank_toppopular: 'Top Popular',
  dbh_storerank_topsellers: 'Top Sellers',
  dbh_storerank_newandtrending: 'New and Trending',
  dbh_storerank_topwishlists: 'Top Wish Lists',
  dbh_storerank_newrelease: 'New Release',
  dbh_storerank_upcoming: 'Upcoming',
  dbh_storerank_mostplayed: 'Most Played',
  dbh_storerank_bestselling: 'Best Selling',
  dbh_storerank_mostdownloaded: 'Most Downloaded',
  dbh_storerank_newgames: 'New Games',
  dbh_storerank_comingsoon: 'Coming Soon',
  dbh_storerank_indiesgames: 'Indies Games',
  dbh_storerank_freetoplay: 'Free to Play',
  dbh_storerank_bestsellers: 'Best Sellers',

  dbh_lasted7d: 'Lasted 7d',

  dbh_metric_dau: 'DAU',
  dbh_metric_avg_dau: 'Avg DAU',
  dbh_metric_sum_iap_rev: 'Sum IAP Rev',
  dbh_metric_avg_pcu: 'Avg PCU',
  dbh_metric_sum_units: 'Sum Units',
  dbh_metric_sum_revenue_console: 'Sum Revenue',
  dbh_spotlight_tip_bigriser_dau: 'Big Riser: Games with over 18% week-over-week Avg DAU growth, ranked by the absolute increase in users.',
  dbh_spotlight_tip_bigriser_pcu: 'Big Riser: Games with over 18% week-over-week Avg PCU growth, ranked by the absolute increase in users.',
  dbh_spotlight_tip_bigriser_console_dau: 'Big Riser: Games with over 18% week-over-week Avg DAU growth, ranked by the absolute increase in users.',
  dbh_metric_mau: 'MAU',
  dbh_metric_revenue: 'Revenue($)',
  dbh_metric_revenue_s: 'Revenue($)',
  dbh_metric_newusers: 'New',
  dbh_metric_d2: 'D2',
  dbh_metric_arpu: 'ARPU($)',
  dbh_metric_arppu: 'ARPPU($)',
  dbh_metric_payer_growth: 'Payer%',
  dbh_metric_payer: 'Payer',
  dbh_metric_pcu: 'PCU',
  dbh_metric_aotmin: 'AOT(min)',
  dbh_metric_tru: 'TNU',
  dbh_metric_region: 'Region',
  dbh_metric_phase: 'Phase',
  dbh_metric_game: 'Game',
  dbh_metric_p_heat: 'P.Heat',
  dbh_metric_pheat: 'P Heat',
  dbh_metric_topcharts: 'Topcharts',
  dbh_metric_freetop10: 'Free #1-10',
  dbh_metric_release: 'Release',
  dbh_metric_newandtrending: 'New and Trending',
  dbh_metric_rank: 'Rank',
  dbh_metric_free: 'Free',
  dbh_metric_steamwishlist: 'Steam Wish List',
  dbh_metric_gamalytic_steam_daily_wishlist: 'Gamalytic Steam Daily Wishlist',
  dbh_metric_gamalytic_steam_lifetime_wishlist: 'Gamalytic Steam Lifetime Wishlist',
  dbh_metric_hourswatched: 'Hours Watched',
  dbh_metric_peakccv: 'Peak CCV',
  dbh_metric_steamtopsellers: 'Steam Top Sellers',
  dbh_metric_steamtopsellers_combine: 'Store Top Seller',
  dbh_metric_digitalarppu_usonly: 'Digital ARPPU(US)',
  dbh_metric_digital_revenue: 'Digital Revenue',
  // dbh_metric_units_combine: 'Full Game Units',
  // dbh_metric_gsd_combine: 'EU Full Game Units',
  dbh_metric_units_combine: 'Base Game Units',
  dbh_metric_gsd_combine: 'EU Base Game Units',
  dbh_metric_lifetime_player: 'Lifetime Player',

  dbh_metric_revenue_dol: 'Revenue($)',
  dbh_metric_New: 'New',
  dbh_metric_d2_t1: 'D2(T-1)',
  dbh_metric_arpu_dol: 'ARPU($)',
  dbh_metric_payer_pre: 'Payer%',

  dbh_metric_calibrated_data: 'Calibrated Data(DataBrain校准数据)',
  dbh_metric_dataof_comesfrom: 'Data of {sourceName} comes from ',
  dbh_metric_dataof_comes: 'Data comes from ',
  dbh_metric_rankingdata_of: 'Ranking Data of icon {sourceName} comes from',
  dbh_metric_dataBrain_calibrated_details:
    'DataBrain Calibrated Data (DataBrain校准数据) Click the game name to see details.',
  dbh_metric_databrain_text_desc: `The DataBrain calibration data is based on prediction of algorithm model. The input factors include real data of competitor games acquired, real data of own games in partial countries, store ranks, data trends provided by Annie and Sensor tower, etc. Please feel free to contact ivyyfchen, if you have any feedback or question on data performance of competitor games.`,

  // spotlight 悬浮窗文案
  dbh_spotlight_tip_avg: 'Take the AVG value in selected time interval.',
  dbh_spotlight_tip_sum: 'Take the Sum value in selected time interval.',
  dbh_spotlight_tip_sum_units: 'Take the Sum value in selected time interval.',
  dbh_spotlight_tip_revenue_commission: 'Revenue has removed 30% commission from in-app purchases, subscriptions and paid app downloads.',
  dbh_spotlight_tip_sum_revenue_commission: 'Revenue has removed 30% commission from in-app purchases, subscriptions and paid app downloads.',
  dbh_spotlight_tip_mobile_range: 'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_spotlight_tip_ranking_data_of: 'Ranking Data of {source} comes from ',
  dbh_spotlight_tip_count_countries: 'Count the number of countries that entered the Top 10 of the {chart} on that day.',
  dbh_spotlight_tip_free_ranking_data_of: 'Ranking Data of {freeSource} comes from {appStoreSource}.',
  dbh_spotlight_tip_free_count_countries: 'Count the number of countries that entered the Top 10 of the Free Chart on that day.',
  dbh_spotlight_tip_newrelease_ranking_data_of: 'Ranking Data of {newGamesSource} comes from {playStationSource}.',
  dbh_spotlight_tip_newrelease_count_countries: 'Count the number of countries that entered the Top 10 of the Free Chart on that day.',
  dbh_spotlight_tip_comingsoon_ranking_data_of: 'Ranking Data of {comingSoonSource} comes from {playStationSource}.',
  dbh_spotlight_tip_comingsoon_count_countries: 'Count the number of countries that entered the Top 10 of the Free Chart on that day.',
  dbh_spotlight_tip_play_station: 'Play Station',
  dbh_spotlight_tip_ign_trailer: 'Total aggregated views from {ign}IGN YouTube official channel for upcoming mobile game trailers from {databrain}DataBrain.',
  dbh_spotlight_tip_console_dau_def: 'Definition: Daily Active Users',
  dbh_spotlight_tip_console_dau_granularity: 'Time Granularity: Daily',
  dbh_spotlight_tip_console_dau_update: 'Data Update: Updated every Thursday',
  dbh_spotlight_tip_console_dau_agg: 'Aggregation method by time: Daily average',
  dbh_spotlight_tip_console_dau_source: 'Data Source: ',
  dbh_spotlight_tip_digital_revenue: 'Digital Revenue($)',
  dbh_spotlight_tip_steam_wishlist: 'Ranking Data of {wishlistSource} comes from {steamSource}',

  // 首页搜索
  dbh_search_placeholder: 'Search any game or company',
  dbh_autocomplete_tip: 'No matching label',
  dbh_autocomplete_data_lover: 'Data Lover Leaderboard',
  dbh_autocomplete_yearly_poster: 'DataBrain 2025\nHonors Leaderboard',
  dbh_back: 'Back',
  dbh_recent_search: 'Recent Search',
  dbh_search_table_total: '{total} total items',
  dbh_clear_all: 'Clear All',
  dbh_search_trending: 'Trending',
  dbh_result_useful: 'Is the result useful?',
  dbh_search_pos: 'Pos',
  dbh_search_neg: 'Neg',
  dbh_operation_failed_network: 'Operation failed. Please check the network',
  dbh_unfollow_successful: 'Unfollow successful',
  dbh_unfollow: 'Unfollow',
  dbh_follow: 'Follow',
  dbh_feedback_isgod_tips: 'Thank you for your feedback!',
  dbh_searching: 'Search...',
  dbh_searching_company_preview: 'The company preview is under development, ',
  dbh_searching_thanks_patience: 'thanks for your patience.',
  dbh_recent: 'Recent',
  dbh_search: 'Search',

  dbh_versionhistory_helptitle: 'Version History',
  dbh_versionhistory_history: 'Version History',
  dbh_versionhistory_detail: 'Version Details',
  dbh_versionhistory_history_tip:
    "We will be sending monthly product update reports to active DataBrain users from the email address {email}, {br}please check your spam folder if you can't find the email in your inbox.",

  dbh_search_dashboard_tip_woa: `Please go to the sensitive authority system to apply the game access: https://appauth.woa.com`,
  dbh_search_dashboard_tip_intlgame: `Please go to the sensitive authority system to apply the game access: https://appauth.intlgame.com`,
  dbh_search_dashboard_tip_sensitive:
    'For Dashboard sensitive authority, please contact Pteam or ivyyfchen (ivyyfchen@global.tencent.com) to request access.',
  dbh_search_intelligent_tip: `For Intelligence' game permission application please contact velvetjiang.`,
  dbh_search_opinion_tip: `You are unable to view the game data currently, please feel free to contact Sophiaxwxu for permissions.`,
  dbh_search_g_pop_tip: `To apply for GPOP access, please contact Jingli <br/>(jinglichen@tencent.com).`,
  dbh_search_opinion_nodata: `This game has no crawler configurations yet. If you have any questions, please contact sophiaxwxu.`,

  dbh_search_dashboard_tip_t_1:
    'The retention rate of new register users  on day 2.<br/>D2:Number of retained users on day 2 from registration date/ Number of new users on registration date. Registration date is day 1.<br/>Date more than 1 day shows average D2. Sum of retention users on day 2 in the statistical period / Sum of new register users in the statistical period.<br/>T-1 stands for the day before the statistics day.',
  dbh_search_dashboard_tip_global: `Dashboard Game Access Request:<br/>·Tencent Users: Please contact the Studio's Pteam.<br/>·Studio Users: Please contact the Studio's DataBrain representative.<br/>·For any additional inquiries, please contact sallyxue@tencent.com`,

  dbh_ai_recognize_tips: 'AI is recognizing and assisting you to fill required information...',
  dbh_ai_recognize_estimated_time_text: 'With an estimated processing time of {range} minutes',
  dbh_report_uploader_footer_linker_text: 'View reports list',
};
